module.exports = __webpack_public_path__ + "static/media/3.43717c96.png";